/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StatusPollingDto } from '../../models/status-polling-dto';

export interface GetCustomerSubmissionStatusLongPoll$Params {

/**
 * UUID to identify the svg (tenancy id)
 */
  svgId: string;

/**
 * UUID to identify the customer
 */
  customerId: string;

/**
 * ID of customer submission requested via creat or update dkv dpi api
 */
  submissionId: string;
}

export function getCustomerSubmissionStatusLongPoll(http: HttpClient, rootUrl: string, params: GetCustomerSubmissionStatusLongPoll$Params, context?: HttpContext): Observable<StrictHttpResponse<StatusPollingDto>> {
  const rb = new RequestBuilder(rootUrl, getCustomerSubmissionStatusLongPoll.PATH, 'get');
  if (params) {
    rb.path('svgId', params.svgId, {});
    rb.path('customerId', params.customerId, {});
    rb.path('submissionId', params.submissionId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StatusPollingDto>;
    })
  );
}

getCustomerSubmissionStatusLongPoll.PATH = '/svgs/{svgId}/customers/{customerId}/dkv-customer-submission/{submissionId}/long-polling';
